import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import LocaleSwitcher from "../common/components/LocaleSwitcher";

const Registration = () => {
  const [localestate, setLocaleState] = React.useState({
    checkedA: true,
  });
  const [occasions, setOccasions] = useState([]);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();

  useEffect(() => {
    if (i18n.language === "en" || i18n.language === undefined) {
      setLocaleState({ checkedA: false });
    } else {
      setLocaleState({ checkedA: true });
    }
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    company: "",
    card: state
  });

  useEffect(() => {
    // Update formData.company when language changes
    const translatedCompany = t("robi-axiata-plc");
    setFormData((prevFormData) => ({
      ...prevFormData,
      company: translatedCompany,
    }));
  }, [t]);

  const [error, setError] = useState({
    name: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const onSubmitHandler = (e) => {
    e.preventDefault();
    let newError = { ...error };

    if (formData.name === "") {
      newError = {
        ...newError,
        name: "Enter name",
      };
    } else {
      newError = {
        ...newError,
        name: "", // Clear the error message if name is not empty
      };
    }

    setError(newError);

    if (formData.card !== "" && formData.name !== "") {
      navigate("/card-preview", { state: formData });
    }

  };

  const localeHandler = (checked) => {
    if (checked) {
      i18n.changeLanguage("bn");
    } else {
      i18n.changeLanguage("en");
    }
  };



  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 300);
  }, []);


  return (
    <>

      <div className="w-full h-screen overflow-hidden relative flex justify-center items-center flex-col px-4">
        <img
          className="hidden md:block absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
          src="/background.png"
          alt=""
        />
        <img
          className="md:hidden absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
          src="/background-sm.png"
          alt=""
        />

        <img
          className="brand_logo absolute top-6 w-[70px] md:w-[100px] xl:w-[143px] 2xl:top-4  left-1/2 -translate-x-1/2 md:left-[90%]"
          src="/logo_robi_horizontal.svg"
          alt=""
        />
        <Link
          to="/"
          type="button"
          className="btn_start absolute left-5 top-0 flex items-center justify-center group bg-[#5B2D90] hover:bg-purple-900 mt-8 md:ml-5 xl:ml-28 w-12 h-12 2xl:w-16 2xl:h-16 rounded-full transition-all"
        >
          <span><svg
            className="relative transition-colors duration-300 delay-200 group-hover:text-white ease"
            width="30"
            height="30"
            fill="#ffffff"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            ></path>
          </svg></span>
        </Link>

        {loader ?
          <div className="relative w-full h-[100px]">
            <svg className="spinner" viewBox="0 0 50 50">
              <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
            </svg>
          </div>
          :
          <div className="relative w-full sm:max-w-sm mt-10 sm:mt-0 bg-white border border-gray-100 rounded-lg mx-auto z-50 box-shadow p-4">
            <div className=" w-full h-full ">
              <div className="locale-wrapper">
                <LocaleSwitcher
                  state={localestate}
                  setState={setLocaleState}
                  localeHandler={localeHandler}
                />
              </div>
              <form className="space-y-3" onSubmit={onSubmitHandler}>
                <h5 className="md:text-2xl text-xl font-bold text-[#BC2626]">
                  {t("title")}
                </h5>
                <div>
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-[#5E6A7A]"
                  >
                    {t("name")}:
                    <span className=" text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="bg-gray-50 text-[18px] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5 focus:outline-none focus:rounded-none"
                    placeholder={t("enterName")}
                    autoComplete="off"
                  />
                  {error?.name && <p className="text-sm text-red-600 mt-1">{error.name}</p>}
                </div>
                <div>
                  <label
                    htmlFor="designation"
                    className="block mb-2 text-sm font-medium text-[#5E6A7A]"
                  >
                    {t("designation")}:
                  </label>
                  <input
                    type="text"
                    name="designation"
                    id="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    className="bg-gray-50 text-[18px]  border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5  focus:outline-none focus:rounded-none"
                    placeholder={t("enterDesignation")}
                    autoComplete="off"
                  />
                </div>
                <div>
                  <label
                    htmlFor="company"
                    className="block mb-2 text-sm font-medium text-[#5E6A7A]"
                  >
                    {t("company")}:
                  </label>
                  <input
                    type="text"
                    name="company"
                    id="company"
                    value={formData.company || ''}
                    onChange={handleChange}
                    className="bg-gray-50 text-[18px] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5  focus:outline-none focus:rounded-none"
                    placeholder={t("enterCompany")}
                    autoComplete="off"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full text-white bg-[#5B2D90] hover:bg-purple-900 focus:ring-4  font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  onSubmit={onSubmitHandler}
                >
                  {t("generateCard")}
                </button>
              </form>
            </div>
          </div>
        }


      </div>
    </>
  );
};

export default Registration;
